import type { FC } from 'react';
import { Card, Flex, Progress, Typography } from 'antd';

const { Text } = Typography;

export interface MetricProgressCardProps {
  title: string;
  metric: string;
  description: string;
  capacityLeft: string;
  capacityRight: string;
  progressPercent: number;
}

export const MetricProgressCard: FC<MetricProgressCardProps> = ({
  title,
  metric,
  description,
  capacityLeft,
  capacityRight,
  progressPercent,
}) => {
  return (
    <Card className="om-kpi-card" styles={{ body: { padding: 20 } }}>
      <Flex vertical gap={12} style={{ height: '100%' }}>
        <Text className="ds-card-label">{title}</Text>
        <Text className="ds-kpi-value om-kpi-card__metric">{metric}</Text>
        <Text type="secondary" className="om-kpi-card__description">
          {description}
        </Text>
        <div className="om-kpi-card__capacity">
          <Flex justify="space-between" align="center">
            <Text className="ds-small-label">{capacityLeft}</Text>
            <Text className="ds-small-label">{capacityRight}</Text>
          </Flex>
          <Progress
            percent={progressPercent}
            showInfo={false}
            strokeColor="var(--evimo-blue)"
            trailColor="#e8eef8"
            size={{ height: 8 }}
          />
        </div>
      </Flex>
    </Card>
  );
};
